export function getEffectiveDatesRangeAsString({
  effectiveStartDate,
  effectiveEndDate,
} = {}) {
  return [effectiveStartDate, effectiveEndDate].filter(Boolean).join(',')
}
